import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import {  RequestResponseDesabilitar, RequestResponseGetAll, Usuario } from 'src/app/shared/models/user.interface';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { Observable, throwError } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UsuariosService {
  constructor(private http:HttpClient,private router: Router,private alert:AlertHelper) { }
  //Create_usuario
  crearUsuario(user:Usuario): Observable<RequestResponse> {
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/usuario/crear`,user)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //GetAll_usuario
  traerUsuarios(): Observable<RequestResponseGetAll> | any {
    return this.http
    .get<RequestResponseGetAll >(`${environment.API}/rrhh/usuario/`)
    .pipe(
      map((res:RequestResponseGetAll) =>{
        return res.data;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //obtenerTodosUsuariosAsync
  async traerUsuariosAsync(): Promise<RequestResponseGetAll> {
    try {
      return await this.http.get<RequestResponseGetAll>(`${environment.API}/rrhh/usuario/`).toPromise();
    } catch (error) {
      return { success: false, msg: 'Hubo un error al obtener los usuarios.' } as RequestResponseGetAll
    }
  }
  //Desabilitar_usuario
  deshabilitarUsuario(user:any): Observable<RequestResponseDesabilitar>  {
    return this.http
    .put<RequestResponseDesabilitar >(`${environment.API}/rrhh/usuario/modificar/${user.id}`,user)
    .pipe(
      map((res:RequestResponseDesabilitar) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Actualizar_usuario
  actualizarUsuario(user:any): Observable<RequestResponseDesabilitar>  {
    return this.http
    .put<RequestResponseDesabilitar >(`${environment.API}/rrhh/usuario/modificar/${user.id}`,user)
    .pipe(
      map((res:RequestResponseDesabilitar) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }

  private handlerError(err: any):Observable<never>{
    let errorMessage = "";
    if (err) {
      errorMessage = `Error: code ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }
  //Obtener_usuario
  obtenerUsuario(id: number): Observable<RequestResponse> {
    return this.http
      .get<RequestResponse>(`${environment.API}/rrhh/usuario/${id}`)
      .pipe(
        map((res: RequestResponse) => {
          return res
        }),
        catchError((err) => this.handlerError(err))
      )
  }

}




